import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=ead58fe6&scoped=true"
import script from "./VersionUpdate.vue?vue&type=script&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=ead58fe6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead58fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ead58fe6')) {
      api.createRecord('ead58fe6', component.options)
    } else {
      api.reload('ead58fe6', component.options)
    }
    module.hot.accept("./VersionUpdate.vue?vue&type=template&id=ead58fe6&scoped=true", function () {
      api.rerender('ead58fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VersionUpdate.vue"
export default component.exports